import axios from "axios";
const ApiBasePath = process.env.REACT_APP_BASE_API_URL;
const LivePayoutsPath = '/api/live-payouts';
class LivePayoutsApiClient {
    constructor(getToken) {
        this.instance = axios.create({
            headers: {
                'Content-Type': 'application/json'
            }
        });
        this.instance.interceptors.request.use(async (requestConfig) => {
            const token = await getToken();
            requestConfig.headers['Authorization'] = `Bearer ${token}`;
            return requestConfig;
        });
    }
    getLivePayouts(from) {
        return this.instance.get(`${ApiBasePath}${LivePayoutsPath}`, { params: { from } });
    }
}
export default LivePayoutsApiClient;
